import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Location} from '@angular/common';

declare let swal, $: any;

@Component({
  selector: 'app-relatorio-certificados-nacionais',
  templateUrl: './relatorio-certificados-nacionais.component.html'
})
export class RelatorioCertificadosNacionaisComponent extends Components implements OnInit {

  form: FormGroup;
  filtroPesquisa = {"data_de":"", "data_ate":""};
  alturaTela;

  urlPDF = '';

  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService,
    private _location: Location
  ) {
    super();
    this.alturaTela = window.screen.availHeight - 250;

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8)+'01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'certificados-nacionais' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });

    this.form = formBuilder.group({
      data_de: [],
      data_ate: []
    });

  }

  ngOnInit() {
  }


  gerarRelatorio(){

    window.open(this.global.dominio_site+'/adm/certificados-nacionais/gerar-relatorio/'+ this.filtroPesquisa.data_de+'/'+ this.filtroPesquisa.data_ate +'?tk='+localStorage.getItem('token'), '_blank');

    /*this.urlPDF = '';
    let self = this;

    setTimeout(function(){
      self.urlPDF = self.global.dominio_site+'/adm/certificados-nacionais/gerar-relatorio/'+ self.filtroPesquisa.data_de+'/'+ self.filtroPesquisa.data_ate +'?tk='+localStorage.getItem('token');
    }, 1000);*/

  }

  voltar() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/relatorio-certificados-nacionais.component.ts